export default __webpack_public_path__ + "static/media/Audiophile - Hero.68fe112b.png";